import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {headers} from './fetcher'

const MASTERDATA_API = process.env.REACT_APP_PI_BACKEND_API_MASTERDATA as string

export const masterdataApi = createApi({
  reducerPath: 'masterdataApi',
  baseQuery: fetchBaseQuery({
    baseUrl: MASTERDATA_API,
    headers: {...headers, Authorization: `Bearer ${localStorage.getItem('token')}`},
  }),
  endpoints: (builder) => ({
    getMarerialProducts: builder.query({
      query: (filter: string) => `material-product/datatable?${filter}`,
    }),
  }),
})

export const {useGetMarerialProductsQuery} = masterdataApi
